import { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import "./Login.css";
import { initializeUserData } from "../utils/userCartWishlistUtils";

const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setSuccess("");

    try {
      const response = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_Users_Registration"
      );
      const matchedUser = response.data.find(
        (item) =>
          item.email === formData.email && item.password === formData.password
      );

      if (matchedUser) {
        setSuccess("Login successful!");
        sessionStorage.setItem("user", JSON.stringify(matchedUser));
        initializeUserData(matchedUser);
        setFormData({
          email: "",
          password: "",
        });
        navigate("/");
      } else {
        setError("Invalid credentials. Please try again.");
      }
    } catch (err) {
      console.error(err);
      setError("Error occurred while processing your request.");
    }
  };

  return (
    <>
      <div className="login-wrapper py-3" style={{minHeight:"95vh"}}>
        <div className="login-container">
          <div className="login-left">
            <div className="logo-container mb-2">
              <Link to="/">
                <div className="logo-container">
                  <Link to="/">
                    <div
                      className="mainlogotitle"
                      style={{ fontSize: "34px", fontFamily: "kalanjiyamfont", color:"white" }}
                    >
                      Kalanjiyam
                      <br></br>
                      <span
                        style={{
                          fontSize: "24px",
                          fontFamily: "botiquefont",
                          marginLeft: "100px",
                          color:"white"
                        }}
                      >
                        Boutique.
                      </span>
                    </div>
                  </Link>
                </div>
              </Link>
            </div>
            <p className="login-powered">
              Discover the latest fashion trends with us.
            </p>
            <p className="welcome-message">
              Welcome back, let’s get you shopping!
            </p>
          </div>

          <div className="login-right">
            <h2 className="hello">Login</h2>
            {success ? (
              <p className="success-message">{success}</p>
            ) : (
              <form className="login-form" onSubmit={handleSubmit}>
                <div className="mb-3">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="form-control login-input"
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="password"
                    name="password"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    className="form-control login-input"
                  />
                </div>
                {error && <p className="error-message">{error}</p>}
                <button className="btn login-submit" type="submit">
                  Login
                </button>
              </form>
            )}
            <div className="dont-have-account">
              <p>
                Don't have an account?{" "}
                <span>
                  <Link to="/register" className="register-link">
                    Register here!
                  </Link>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
